import { Component, OnInit } from "@angular/core";
import { UtilsService } from "../../../../auth/service/utils.service";
import { TaskService } from "../../task.service";

@Component({
  selector: "app-my-task",
  templateUrl: "./my-task.component.html",
  styleUrls: ["./my-task.component.scss"],
})
export class MyTaskComponent implements OnInit {
  public myTask: any = [];

  constructor(
    public _utilsService: UtilsService,
    public _taskService: TaskService,
  ) {}

  async ngOnInit() {
    this.myTask = await this._taskService.getMine();
    this.myTask = this.myTask.filter((task: any) => task.view_because === "assigned_to_me");
    this.myTask = this.myTask.filter((task: any) => task.status !== 2);
    this.myTask = this.myTask.slice(0, 5);
  }

  closeModal() {
    this._utilsService.popupOpenTaskIsOpen = false;
  }
}
